<template>
  <div class="relative">
    <div class="text-sm text-text transition duration-200 flex group cursor-pointer"
         @click="popupOpen = !popupOpen">
      <IconMoreSettings class="text-icon mr-4 group-hover:text-icon-hover transition duration-200"/>
      {{ $t('incomeSettings') }}
    </div>
    <div v-if="popupOpen" class="settings-popup"
         v-on-click-away="hidePopup">
      <div class="text-xl font-bold text-text leading-tight mb-8">{{ $t('incomeSettings') }}</div>
      <BaseSelect :value="defaultIncome"
                  :options="incomes"
                  track-by="id"
                  :allow-empty="false"
                  :selectLabel="$t('pickIncomeSource')"
                  label="title"
                  @select="handleDefaultIncome"/>

      <div class="text-text-ternary mt-8">{{ $t('incomeSourceTip') }}</div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters, mapMutations, mapState} from "vuex";
import BaseSelect from "@/components/UI/BaseSelect/BaseSelect";
import IconMoreSettings from "@/components/icons/IconMoreSettings";
import {directive as onClickAway} from "vue-clickaway";

export default {
  name: "IncomeSpaceSettings",
  components: {BaseSelect, IconMoreSettings},
  directives: {
    onClickAway: onClickAway
  },
  data() {
    return {
      popupOpen: false,
      income: null,
    }
  },
  computed: {
    ...mapState('space/incomes', ['incomes']),
    ...mapGetters('space/incomes', ['defaultIncome']),
  },
  methods: {
    ...mapActions('space/incomes', ['saveDefaultIncomeSource']),
    ...mapMutations('space/incomes', ['setDefaultIncomeSource']),
    hidePopup() {
      this.popupOpen = false;
    },
    async handleDefaultIncome(income_source) {
      try {
        const res = await this.saveDefaultIncomeSource(income_source.id)
        if (res.body.success) {
          this.setDefaultIncomeSource(res.body.data);
        }
      } catch (e) {
        console.error(e)
        this.$toasted.error('Ошибка')
      }
    },
  },
  i18n: {
    messages: {
      en: {
        incomeSettings: 'Income source settings',
        pickIncomeSource: 'Select default income source',
        incomeSourceTip: 'This source of income will be set for all new receipts that will be imported when syncing with banks, if you use this option.',
      },
      ru: {
        incomeSettings: 'Настройки источников дохода',
        pickIncomeSource: 'Выберите источник дохода по умолчанию',
        incomeSourceTip: 'Этот источник дохода будет устанавливаться для всех новых поступлений, которые будут импортироваться при синхронизации с банками, если вы будете использовать эту возможность.',
      }
    }
  }
}
</script>

<style scoped lang="scss">
.settings-popup {
  @apply absolute -right-16 -bottom-5 z-110 transform translate-y-full
  bg-block shadow-popup p-12 rounded;
  width: 415px;

  &:before {
    content: '';
    @apply absolute bg-block;
    top: -3px;
    right: 24%;
    width: 7px;
    height: 7px;
    transform: rotate(-45deg);
    clip-path: polygon(0 0, 100% 0, 100% 100%);
  }

  @media(max-width: 1229px) {
    @apply -right-8;
  }
}
</style>